import CardWrapper from '../../components/wrapper/card';
import { a11yProps, CustomTabPanel } from '../deals';
import React, { useState } from 'react';
import { RequestReviewComponent, ReviewComponent } from '../../components/review_management';
import { Tab, Tabs } from '@mui/material';

const ReviewManagementPage = () => {
  const [selectedTab, setSelectedTab] = useState<0 | 1>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
    setSelectedTab(newValue);
  };

  return (
    <CardWrapper minHeight="80vh" overflow="auto">
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label="Review details tabs"
      >
        <Tab
          label="Reviews"
          {...a11yProps(0)}
        />
        <Tab
          label="Requests"
          {...a11yProps(1)}
        />
      </Tabs>

      <CustomTabPanel value={selectedTab} index={0}>
        <ReviewComponent />
      </CustomTabPanel>

      <CustomTabPanel value={selectedTab} index={1}>
        <RequestReviewComponent />
      </CustomTabPanel>
    </CardWrapper>
  );
};

export default ReviewManagementPage;